/**
 * Immutable metadata embedded into the current frontend bundle at build time.
 */
export interface FrontendBuildInfo {
  version: string;
  buildCommit: string;
  builtAt: string;
}

/**
 * Current frontend bundle identity served by the browser.
 *
 * These values are compared against `/version.json`, which is emitted during
 * the frontend build and served by the frontend container itself.
 */
export const FRONTEND_BUILD_INFO: FrontendBuildInfo = {
  version: __APP_VERSION__,
  buildCommit: __FRONTEND_BUILD_COMMIT__,
  builtAt: __FRONTEND_BUILT_AT__,
};

export default FRONTEND_BUILD_INFO;
